module.exports = __webpack_public_path__ + "static/media/404.fe8bed5f.png";